import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'hnDate',
  standalone: true,
})
export class HnDatePipe implements PipeTransform {
  private datePipe = new DatePipe('en-US');

  transform(value: string | number | Date | null | undefined, format = 'dd/MM/yyyy HH:mm'): string | null {
    if (!value) return null;
    return this.datePipe.transform(value, format, 'UTC-6');
  }
}
